import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import DashboardPage from './pages/DashboardPage'
import CVEditorPage from './pages/CVEditorPage'
import CVAnalysisPage from './pages/CVAnalysisPage'
import UploadPage from './pages/UploadPage'
import { Toaster } from './components/ui/sonner'

// Protected Route wrapper
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const token = useAuthStore((state) => state.token)
  const user = useAuthStore((state) => state.user)
  const fetchUser = useAuthStore((state) => state.fetchUser)

  useEffect(() => {
    // Only fetch user if we have a token but no user data
    if (token && !user) {
      fetchUser()
    }
  }, [token, user, fetchUser])

  if (!token) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="editor/:id/analysis" element={<CVAnalysisPage />} />
          <Route path="editor/analysis" element={<CVAnalysisPage />} />
          <Route path="editor/:id" element={<CVEditorPage />} />
          <Route path="editor" element={<CVEditorPage />} />
          <Route path="upload" element={<UploadPage />} />
        </Route>
      </Routes>
      <Toaster />
    </>
  )
}

export default App

